import { ICampaignFormState, IEditCampaign } from "../../App/Typings/Campaigns";

export function getCampaignBody(campaignId: string, values: ICampaignFormState | undefined) {
  return {
    campaignId: campaignId,
    name: values?.campaignName,
    startDate: new Date(values?.startDate || ""),
    endDate: new Date(values?.endDate || ""),
    ongoing: values?.ongoing,
    welcomeMessage: values?.welcomeMessage,
    welcomeMessageSubject: values?.welcomeMessageSubject,
    campaignType: values?.campaignType,
  } as IEditCampaign;
}
